export default(state = "", action) => {
    switch(action.type){
        case 'GET_PXQ':
            return action.payload;
        default: return state;
    }
}